module.exports = __webpack_public_path__ + "static/img/search-white.eae71a2.png";